"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var quagga_1 = __importDefault(require("quagga"));
// Composants Material UI
var Button_1 = __importDefault(require("@mui/material/Button"));
// Styles
require("./Scanner.css");
var scannerConfig = {
    "inputStream": {
        "type": "LiveStream",
        "constraints": {
            "width": { "min": 300 },
            "height": { "min": 300 },
            "facingMode": "environment",
            "aspectRatio": { "min": 1, "max": 2 }
        }
    },
    "locator": {
        "patchSize": "medium",
        "halfSample": true
    },
    "numOfWorkers": 2,
    "frequency": 10,
    "decoder": {
        "readers": ["ean_reader"]
    },
    "locate": true
};
function Scanner(props) {
    // props
    var debug = props.debug, onDetected = props.onDetected;
    // state
    var _a = (0, react_1.useState)(false), initialized = _a[0], setInitialized = _a[1];
    var _b = (0, react_1.useState)(1), tries = _b[0], setTries = _b[1];
    (0, react_1.useEffect)(function () {
        console.log('-- Scanner useEffect --');
        quagga_1.default.init(scannerConfig, function (err) {
            if (err) {
                console.log(err, "error msg");
            }
            setInitialized(true);
            quagga_1.default.start();
            console.log('-- Scanner useEffect start --');
            return function () {
                quagga_1.default.stop();
                console.log('-- Scanner useEffect stop --');
            };
        });
        //detecting boxes on stream
        quagga_1.default.onProcessed(function (result) {
            var drawingCtx = quagga_1.default.canvas.ctx.overlay, drawingCanvas = quagga_1.default.canvas.dom.overlay;
            if (result) {
                if (result.boxes) {
                    drawingCtx.clearRect(0, 0, Number(drawingCanvas.getAttribute("width")), Number(drawingCanvas.getAttribute("height")));
                    result.boxes
                        .filter(function (box) {
                        return box !== result.box;
                    })
                        .forEach(function (box) {
                        quagga_1.default.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, {
                            color: "green",
                            lineWidth: 2
                        });
                    });
                }
                if (result.box) {
                    quagga_1.default.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, {
                        color: "#00F",
                        lineWidth: 2
                    });
                }
                if (result.codeResult && result.codeResult.code) {
                    quagga_1.default.ImageDebug.drawPath(result.line, { x: "x", y: "y" }, drawingCtx, { color: "red", lineWidth: 3 });
                }
            }
        });
        quagga_1.default.onDetected(detected);
    }, []);
    var detected = function (result) {
        console.log('-- Scanner -- detected', result.codeResult.code);
        quagga_1.default.stop();
        console.log('-- Scanner stop --');
        onDetected(result.codeResult.code);
        setTries(tries + 1);
    };
    var restart = function () {
        console.log('-- Scanner restart --');
        quagga_1.default.init(scannerConfig, function (err) {
            if (err) {
                console.log(err, "error msg");
            }
            setInitialized(true);
            quagga_1.default.start();
            console.log('-- Scanner useEffect start --');
            return function () {
                quagga_1.default.stop();
                console.log('-- Scanner useEffect stop --');
            };
        });
    };
    return (
    // If you do not specify a target,
    // QuaggaJS would look for an element that matches
    // the CSS selector #interactive.viewport
    (0, jsx_runtime_1.jsxs)("div", __assign({ className: "scanner" }, { children: [tries > 1 ? (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ onClick: restart, color: "primary" }, { children: "Nouveau scan" }), void 0) }, void 0) : null, (0, jsx_runtime_1.jsx)("div", __assign({ className: "container" }, { children: (0, jsx_runtime_1.jsx)("div", { id: "interactive", className: "viewport" }, void 0) }), void 0)] }), void 0));
}
;
exports.default = Scanner;
//# sourceMappingURL=Scanner.js.map